<div class="card-body" *ngIf="isPageReady && address">
  <div class="flex flex-col w-full">
    <div class="w-full pb-3 pr-3">
      <h4>{{address.name}}</h4>
    </div>
    <div style="margin-top: -12px;" *ngIf="address.line1" class="w-full pb-3 pr-3">
      <h5>{{address.line1}}</h5>
    </div>
    <div *ngIf="address.line2" style="margin-top: -12px;" class="w-full pb-3 pr-3">
      <h5>{{address.line2}}</h5>
    </div>
    <div *ngIf="address.line3" style="margin-top: -12px;" class="w-full pb-3 pr-3">
      <h5>{{address.line3}}</h5>
    </div>
    <div style="margin-top: -12px;" class="w-full pb-3 pr-3">
      <h5>{{address.city}} {{address.state}} {{address.zipcode}}</h5>
    </div>
    <div *ngIf="address.attn" style="margin-top: -12px;" class="w-full pb-3 pr-3">
      <h5>{{address.attn}}</h5>
    </div>
  </div>
</div>